// apps/mcv-client/src/features/vault/dashboard/QuickStatsPanel.tsx

interface QuickStatsPanelProps {
  total: number;
  active: number;
  expiringSoon: number;
  expired: number;
}

export const QuickStatsPanel = ({ total, active, expiringSoon, expired }: QuickStatsPanelProps) => {
  const stats = [
    { label: 'Total Records', value: total, color: 'text-primary-50' },
    { label: 'Active', value: active, color: 'text-good' },
    { label: 'Expiring Soon', value: expiringSoon, color: 'text-warning' },
    { label: 'Expired', value: expired, color: 'text-error-50' },
  ];

  return (
    <div className="bg-white rounded-xl border border-grey-900 shadow-sm p-6 min-h-40">
      <h3 className="font-semibold text-sm text-grey-400 uppercase tracking-wider mb-4">
        Quick Stats
      </h3>
      <dl className="grid grid-cols-2 gap-4">
        {stats.map((stat) => (
          <div key={stat.label}>
            <dd className={`text-[28px] font-bold leading-none ${stat.color}`}>{stat.value}</dd>
            <dt className="text-[13px] text-grey-400 mt-1">{stat.label}</dt>
          </div>
        ))}
      </dl>
    </div>
  );
};
